import '../main.less';
import React from 'react';
import ModalBox from '../../../../shared/modal';
import { Field, reduxForm } from 'redux-form';

import SelectField from '../../../../shared/form-elements/select/field';
import Checkbox from '../../../../shared/form-elements/checkbox';
import Input from '../../../../shared/form-elements/input';
import Textarea from '../../../../shared/form-elements/textarea';
import { formatMoney } from '../../../../shared/format';

const Form = props => {
	const { submitPayoutRequest, currentPayout, clearDirtyFieldsAtCreateRequest, maxDailyLeads } = props;

	return (
		<div className="payout-request-form-wrap payouts-form-in-modal">
			<p className="margin-10-0">
				<button className="ui-btn ui-btn-primary">
					Current payout: {currentPayout && currentPayout.amount && Number(currentPayout.amount)}
					{` ${currentPayout && currentPayout.currency || ''}`}
				</button>
				<button className="ui-btn ui-btn-primary margin-0-10">
					Max leads daily per 7 days: {maxDailyLeads}
				</button>
			</p>
			<form
				className="ui-form payouts-form__main clearfix display-flex-column"
				onSubmit={props.handleSubmit(submitPayoutRequest)}
			>
				<div className="payout-request-form__main-fields">
					<div className="ui-form__element">
						<Field
							name="affiliate_id"
							placeholder={props.intl('Affiliate')}
							component={SelectField}
							searchable={true}
							showLabel={false}
							multi={false}
							options={props.affiliatesLookups}
							onChange={() => {
								setTimeout(props.getCurrentPayout, 100);
								clearDirtyFieldsAtCreateRequest('affiliate_id');
							}}
						/>
					</div>
					<div className="ui-form__element">
						<Field
							name="offer_id"
							placeholder={props.intl('Offer id')}
							component={SelectField}
							searchable={true}
							showLabel={false}
							multi={false}
							options={props.offersLookup}
							onChange={() => {
								setTimeout(props.getCurrentPayout, 100);
								clearDirtyFieldsAtCreateRequest('offer_id');
							}}
						/>
					</div>
					<div className="ui-form__element">
						<Field
							name="country_id"
							placeholder={props.intl('Country id')}
							component={SelectField}
							showLabel={false}
							searchable={true}
							multi={true}
							options={props.locationsLookup}
							onChange={() => {
								setTimeout(props.getCurrentPayout, 100);
								clearDirtyFieldsAtCreateRequest('country_id');
							}}
						/>
					</div>
				</div>
				<div className="payout-request-form__main-fields">
					<div className="ui-form__element amount">
						<Field
							name="amount"
							placeholder={props.intl('Payout amount (Leave empty if MAX)')}
							showLabel={false}
							component={Input}
							normalize={value => formatMoney(value, true)}
						/>
					</div>
					<div className="ui-form__element amount">
						<Field
							name="planned_volume"
							placeholder={props.intl('Planned volume')}
							component={Input}
							showLabel={false}
							normalize={value => formatMoney(value, true)}
						/>
					</div>
					<div className="ui-form__element amount">
						<Field
							name="traffic_source"
							placeholder={props.intl('Traffic source')}
							component={SelectField}
							multi={false}
							showLabel={false}
							searchable={false}
							options={props.trafficSources}
						/>
					</div>
				</div>
				<div className="payout-request-form__main-fields">
					<div className="ui-form__element">
						<Field
							name="campaign_id"
							placeholder={props.intl('Campaign id')}
							component={SelectField}
							searchable={true}
							multi={false}
							options={props.campaignsLookup}
							showLabel={false}
							onChange={() => {
								setTimeout(props.getCurrentPayout, 100);
								clearDirtyFieldsAtCreateRequest('campaign_id');
							}}
						/>
					</div>
					<div className="ui-form__element amount">
						<Field
							name="sid_type"
							placeholder={props.intl('Sid type')}
							component={SelectField}
							multi={false}
							showLabel={false}
							searchable={false}
							options={[1, 2, 3, 4, 5].map( item => `sid${item}`).map(item =>({ value: item, label: item }))}
							onChange={() => {
								setTimeout(props.getCurrentPayout, 100);
								clearDirtyFieldsAtCreateRequest('sid_type');
							}}
						/>
					</div>
					<div className="ui-form__element amount">
						<Field
							name="sid"
							placeholder={props.intl('Sid')}
							component={SelectField}
							searchable={true}
							multi={false}
							showLabel={false}
							options={props.sidLookup}
							onChange={() => setTimeout(props.getCurrentPayout, 100)}
						/>
					</div>
				</div>
				<div className="payout-request-form__main-fields width-100-p">

					<div className="ui-form__element amount">
						<Field
							name="is_traffic_scaling"
							placeholder={props.intl('Traffic scaling')}
							component={Checkbox}
							showLabel={false}
						/>
					</div>
				</div>
				<div className="payout-request-form__main-fields width-100-p">
					<div className="width-100-p">
						<Field
							showLabel={false}
							name="comment"
							placeholder={props.intl('Comment')}
							component={Textarea}
						/>
					</div>
				</div>
				<div className="display-flex margin-top-15">
					<button type="submit" className="ui-btn ui-btn-primary apply">
						{props.intl('Apply')}
					</button>
					<button
						className="ui-btn ui-btn-cancel cancel"
						onClick={e => {
							e.preventDefault();
						}}
					>
						{props.intl('Cancel')}
					</button>
				</div>
			</form>
		</div>
	);
};

const Main = props =>
	<ModalBox
		title={props.intl('Create a payout request')}
		body={Form(props)}
		isOpen={props.isRequestFormVisible}
		onClose={props.toggleRequestForm}
		className="form-modal payout-request-modal"
	/>;

export default reduxForm({ form: 'createPayoutRequestForm' })(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/components/forms/create-payout-request/main.js